export enum Directions {
  Down = `down`,
  DownCenter = `downCenter`,
  DownRight = `downRight`,
  Right = `right`,
  RightCenter = `rightCenter`,
  RightBottom = `rightBottom`,
  Up = `up`,
  UpRight = `upRight`,
  UpCenter = `upCenter`,
  Left = `left`,
  LeftCenter = `leftCenter`,
  LeftBottom = `leftBottom`,
}

export enum PositioningStrategy {
  Absolute = `absolute`,
  Fixed = `fixed`,
}

export enum PositionParentType {
  OffsetParent = `offsetParent`,
  ParentElement = `parentElement`,
}

// use "const enum" for backward compatibility with raw menu state strings
// "const enum" forces Typescript to simply inline the enum value when compiled
export const enum MenuState {
  Open = `open`,
  Closed = `closed`,
}

export interface DropMenuAttrs {
  open?: boolean;
  offset?: number;
  skidding?: number;
  'show-arrow'?: boolean;
  direction?: Directions;
  'position-strategy'?: PositioningStrategy;
  'force-stacking'?: boolean;
  'allowed-flip-directions'?: Directions[];
  'experimental-positioning'?: boolean;
  'prevent-close'?: boolean;
  'prevent-close-selectors'?: string[];
  'prevent-stacking'?: boolean;
  'disable-auto-focus'?: boolean;
  'disable-auto-update'?: boolean;
}
